export default __webpack_public_path__ + "static/media/johnson-controls.d0e1b6ac.jpg";